// extracted by mini-css-extract-plugin
export default {"inputsContainer":"login_inputsContainer__1nWbA","backgroud":"login_backgroud__VX9ex","btnContainer":"login_btnContainer__BMI8R","mainError":"login_mainError__VvqPe"};